import { FILTER_SAVED } from '../actionTypes/floorPlan.types';

export function saveFilterFloorPlan(data: object) {
  return {
    type: FILTER_SAVED,
    payload: {
      ...data,
    },
  };
}
